import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

const COLORS = ['#8b5cf6', '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#ec4899'];

const FUNNEL_STEPS = [
  { keys: ['page_view'], label: 'Visitas' },
  { keys: ['uploader_visible'], label: 'Vieron uploader' },
  { keys: ['upload_click'], label: 'Clic en subir' },
  { keys: ['example_image_click'], label: 'Clic ejemplo' },
  { keys: ['upload_success'], label: 'Subida exitosa' },
  { keys: ['compression_success', 'tool_success', 'crop_apply', 'rotate_apply'], label: 'Procesamiento exitoso' },
  { keys: ['download_click', 'download_success', 'batch_download_zip'], label: 'Descargaron' },
];

interface FunnelChartProps {
  events: Array<{ event_type: string; session_id: string }>;
}

const FunnelChart = ({ events }: FunnelChartProps) => {
  const funnelData = FUNNEL_STEPS.map(step => {
    const sessions = new Set(events.filter(e => step.keys.includes(e.event_type)).map(e => e.session_id));
    return { name: step.label, value: sessions.size };
  });

  const maxVal = funnelData[0]?.value || 1;

  return (
    <Card>
      <CardHeader>
        <CardTitle>Embudo de Conversión (sesiones únicas)</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {funnelData.map((step, i) => {
            const pct = maxVal > 0 ? Math.round((step.value / maxVal) * 100) : 0;
            const prevValue = i > 0 ? funnelData[i - 1].value : null;
            const dropOff = prevValue && prevValue > 0
              ? Math.round(((prevValue - step.value) / prevValue) * 100)
              : null;

            return (
              <div key={step.name} className="flex items-center gap-3">
                <span className="text-sm w-44 text-muted-foreground">{step.name}</span>
                <div className="flex-1 bg-muted rounded-full h-6 overflow-hidden">
                  <div
                    className="h-full rounded-full transition-all duration-500"
                    style={{
                      width: `${pct}%`,
                      backgroundColor: COLORS[i % COLORS.length],
                    }}
                  />
                </div>
                <span className="text-sm font-medium w-28 text-right">
                  {step.value} ({pct}%)
                  {dropOff !== null && dropOff > 0 && (
                    <span className="text-destructive ml-1 text-xs">−{dropOff}%</span>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default FunnelChart;
